import type { TranslateDictionary } from './en.js';

export const De: TranslateDictionary = {
  'Start airplay': 'AirPlay starten',
  'Stop airplay': 'AirPlay beenden',
  Audio: 'Audio',
  Captions: 'Untertitel',
  'Enable captions': 'Untertitel aktivieren',
  'Disable captions': 'Untertitel deaktivieren',
  'Start casting': 'Übertragung starten',
  'Stop casting': 'Übertragung beenden',
  'Casting to {device}': 'Wird auf {device} gestreamt',
  'Enter fullscreen mode': 'Vollbild',
  'Exit fullscreen mode': 'Vollbild verlassen',
  Mute: 'Stummschalten',
  Unmute: 'Stummschaltung deaktivieren',
  'Enter picture in picture mode': 'Bild-in-Bild-Modus aktivieren',
  'Exit picture in picture mode': 'Bild-in-Bild-Modus deaktivieren',
  Play: 'Abspielen',
  Pause: 'Pause',
  'Playback rate': 'Wiedergabegeschwindigkeit',
  'Playback rate {playbackRate}': 'Wiedergabegeschwindigkeit {playbackRate}',
  Quality: 'Qualität',
  'Seek backward': 'Zurückspulen',
  'Seek forward': 'Vorspulen',
  Settings: 'Einstellungen',
  Auto: 'Auto',
  'audio player': 'Audio-Player',
  'video player': 'Video-Player',
  volume: 'Lautstärke',
  seek: 'Suchen',
  'closed captions': 'Untertitel',
  'current playback rate': 'aktuelle Wiedergabegeschwindigkeit',
  'playback time': 'Wiedergabezeit',
  'media loading': 'Medien werden geladen',
  settings: 'Einstellungen',
  'audio tracks': 'Audiospuren',
  quality: 'Qualität',
  play: 'Abspielen',
  pause: 'Pause',
  mute: 'Stummschalten',
  unmute: 'Stummschaltung deaktivieren',
  'chapter: {chapterName}': 'Kapitel: {chapterName}',
  live: 'Live',
  Off: 'Aus',
  'start airplay': 'AirPlay starten',
  'stop airplay': 'AirPlay beenden',
  'start casting': 'Übertragung starten',
  'stop casting': 'Übertragung beenden',
  'enter fullscreen mode': 'Vollbild',
  'exit fullscreen mode': 'Vollbild verlassen',
  'enter picture in picture mode': 'Bild-in-Bild-Modus aktivieren',
  'exit picture in picture mode': 'Bild-in-Bild-Modus deaktivieren',
  'seek to live': 'Zur Live-Übertragung wechseln',
  'playing live': 'Live-Wiedergabe',
  'seek back {seekOffset} seconds': '{seekOffset} Sekunden zurückspulen',
  'seek forward {seekOffset} seconds': '{seekOffset} Sekunden vorspulen',
  'Network Error': 'Netzwerkfehler',
  'Decode Error': 'Decodierfehler',
  'Source Not Supported': 'Quelle nicht unterstützt',
  'Encryption Error': 'Verschlüsselungsfehler',
  'A network error caused the media download to fail.':
    'Ein Netzwerkfehler hat den Download der Medien verhindert.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Ein Medienfehler hat die Wiedergabe abgebrochen. Die Medien könnten beschädigt sein oder Ihr Browser unterstützt dieses Format nicht.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Ein nicht unterstützter Fehler ist aufgetreten. Der Server oder das Netzwerk ist ausgefallen, oder Ihr Browser unterstützt dieses Format nicht.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Die Medien sind verschlüsselt und es gibt keine Schlüssel zum Entschlüsseln.',
};
